import { atom } from "recoil";
import { ClientUserDTO } from "../Types-DTOs/ClientUser";
import { localStorageEffect } from "./Utils";

export type AuthState = {
  clientUser: ClientUserDTO | undefined;
  token: string | undefined;
};

export const authState = atom<AuthState>({
  key: "authState",
  default: {} as AuthState,
  effects: [localStorageEffect<AuthState>("authState")],
});
